import { useCallback, useState } from 'react'

import { DropDownItem } from 'types/components'

export const useVoucherMembersSelectQuery = () => {
  const [selectedMembers, selectedMembersSet] = useState<DropDownItem[]>([])

  const onSelectMembers = useCallback((member: DropDownItem) => {
    if (!member) return
    selectedMembersSet(prev =>
      prev.some(item => item.value === member.value)
        ? prev.filter(item => item.value !== member.value)
        : [...prev, member]
    )
  }, [])

  return {
    selectedMembers,
    onSelectMembers,
  }
}

export const useVoucherMerchantsSelectQuery = () => {
  const [selectedMerchants, selectedMerchantsSet] = useState<DropDownItem[]>([])

  const onSelectMerchants = (itemOrItems: DropDownItem | DropDownItem[]) => {
    if (Array.isArray(itemOrItems)) {
      selectedMerchantsSet(itemOrItems)
    } else {
      selectedMerchantsSet((prev) =>
        prev.some((m) => m.value === itemOrItems.value)
          ? prev.filter((m) => m.value !== itemOrItems.value)
          : [...prev, itemOrItems]
      )
    }
  }

  return {
    selectedMerchants,
    onSelectMerchants,
  }
}